export class FetchResult {
  isError: boolean;
  errorDescription: string;
  value: object;
}
